export default async () => {
  const entries = document.querySelectorAll('.js-del-headerStripeWrapper');
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "DELHeaderLinksStripeController-lib" */ '@/delonghi/Controllers/DELHeaderLinksStripe/DELHeaderLinksStripeController'
    );
    controller.default();
  }
};
